'use client';

import { useEffect } from 'react';
import { getSearchParam } from '@/app/common/urlParametersUtils.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import {
  getSessionStorage,
  SESSION_STORAGE_KEY,
  setSessionStorage,
} from '@/app/components/search/utils/sessionStorage';

type VersionGuardProps = {
  commonData: CommonData;
};
export const VersionGuard = ({ commonData }: VersionGuardProps) => {
  const { appBuildVersion } = commonData;
  const searchParams = getSearchParams();
  const isDebug = getSearchParam(searchParams, URLParameters.DEBUG) === 'true';

  useEffect(() => {
    const prevAppBuildVersion = getSessionStorage(SESSION_STORAGE_KEY.BUILD_VERSION);
    if (prevAppBuildVersion && prevAppBuildVersion !== appBuildVersion) {
      if (isDebug) {
        console.log('VersionGuard - appBuildVersion changed.', { prevAppBuildVersion, appBuildVersion });
      }
      // window.location.reload();
    }
    setSessionStorage(SESSION_STORAGE_KEY.BUILD_VERSION, appBuildVersion);
  });

  return null;
};
